import { render, staticRenderFns } from "./configureResourcesModal.vue?vue&type=template&id=07cfad90&scoped=true&"
import script from "./configureResourcesModal.vue?vue&type=script&lang=js&"
export * from "./configureResourcesModal.vue?vue&type=script&lang=js&"
import style0 from "./configureResourcesModal.vue?vue&type=style&index=0&id=07cfad90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cfad90",
  null
  
)

export default component.exports